import React from 'react';
import ReactSVG from 'react-svg';
import { NeuroMessage, useDispatch } from "@ignitesales/neuro-application";
import {goToPreferredPath} from "../actions/regions-consumer-online-actions";

const PathOptionButtons = ({ completedPaths, uuid }) => {
  const dispatch = useDispatch();
  const uncompletedPathsList = pathsMap.filter( p => !completedPaths.includes(p.pathKey) );
  const pathOptions = React.useMemo(() => {
    return uncompletedPathsList.map( path =>
      <button
        onClick={()=> {
          dispatch( goToPreferredPath(path.pathKey, `/guide/spa/${uuid}/${path.pathKey}/${path.pageKey}`) )
        }}
        key={ path.pathKey }
        className={`${path.pathKey}Button`}
      >
        <span>
            <ReactSVG src={`/classpath/assets/images/regions-icons/${path.icon}.svg`} />
            <NeuroMessage id={`pathOptions.${path.messageId}`}/>
          </span>
      </button>
    )
  }, [completedPaths]);

  return uncompletedPathsList.length > 0 ? <div className='pathOptionButtons'>
    <NeuroMessage id="pathOptions.pathingHeader" tagName='h2'/>
    <div className='pathOptionButtons--buttons'>{ pathOptions }</div>
  </div> : null;
};

/**
 * pageKey indicates the first page of a path.
 * This map is used to help redirect users to a path
 */
const pathsMap = [
  {
    pathKey: 'bank',
    pageKey: 'checkingBalance',
    icon: 'accounts',
    messageId: 'pathingCheckingBanking',
    param: 'checking'
  },
  {
    pathKey: 'saveAndInvest',
    pageKey: 'savings',
    icon: 'savings',
    messageId: 'pathingSaveInvest',
    param: 'saveAndInvest'
  },
  {
    pathKey: 'loansAndLines',
    pageKey: 'home',
    icon: 'card-check',
    messageId: 'pathingLoansLines',
    param: 'loansAndLines'
  },
  {
    pathKey: 'creditCards',
    pageKey: 'creditCardFeaturesBorrow',
    icon: 'borrow-gray',
    messageId: 'pathingCreditCards',
    param: 'creditCards'
  },
  // {
  //   pathKey: 'financialHealthScore',
  //   pageKey: 'householdSpending',
  //   icon: 'target',
  //   messageId: 'pathingFinancialScore',
  //   param: 'financialHealthScore'
  // }
];


export default PathOptionButtons;
export {
  pathsMap
};
